import React, {useCallback} from 'react';

import Icon, {Icons} from '@pb/kit-component-icon';
import {Pill} from '@pb/kit-component-strip-of-pills';

import type {ItemData} from '@pb/kit-component-query-area-v2';

type Props = {
    item: ItemData,
    onRemove: (item: ItemData) => void,
};

export const QueryPill = ({onRemove, item}: Props) => {
    const onRemoveCallback = useCallback(() => {
        onRemove(item);
    }, [item, onRemove]);

    return (
        <Pill
            removable={true}
            prefix={item.variant === 'EXCLUSION' && <Icon type={Icons.ERROR}/>}
            variant={item.variant}
            name={item.name}
            onRemove={onRemoveCallback}
        />
    );
};
